import React, { useRef, useState } from "react";
import NavMUI from "../../Navbar/NavMUI";
import { redirect, useNavigate } from "react-router-dom";
import "./About.css";
import { useTranslation } from "react-i18next";
import m2building from "../../../../assets/images/About/m2building.png";
import top from '../../../../assets/images/About/circle-chevron-top.svg'
import bottom from '../../../../assets/images/About/view-more-button-icon.svg'

function About({ myref }) {
  const navigate = useNavigate();
  const executeScrollCourse = () => navigate("/");
  const executeScrollContact = () => navigate("/");

  const [btn,setbtn] = useState('block')
  const [btnpress,setbtnpress] = useState('none')

  const showfn = ()=>{
    if(btn=='block'){
      setbtn('none')
      setbtnpress('block')
    }
    else{
      setbtn('block')
      setbtnpress('none')
    }
  }
  
  const { t } = useTranslation();
  return (
    <div className="about" ref={myref}>
        <h2 className="about-head"> {t("About us")}</h2>
        <hr />
        <div className="about-1">
          <p>{t(`about1`)}</p>
          <p>{t(`about2`)}</p>
          <p>{t(`about3`)}</p>
        </div>
        <div className="about-2">
          <p>{t(`about1`)}</p>
          <img src={bottom} id="bottom-btn" onClick={showfn} alt="showmore" style={{display:btn}}/>
          <p style={{display:btnpress}}>{t(`about2`)}</p>
          <p style={{display:btnpress}}>{t(`about3`)}</p>
          <img src={top} id="top-btn" style={{display:btnpress}} alt="showless" onClick={showfn}/>
        </div>
        {/* <img src={m2building}/> */}
      </div>
  );
}

export default About;
